import { BuilderAgentAssistantTools, DataObservatoryCatalogAgentAssistantTools } from '@cloud-native/agent-tools'

export default {
  modelAutocomplete: {
    placeholder: 'Select a model',
    cartoManaged: 'CARTO Managed'
  },
  error: 'Something went wrong',
  showDetails: 'Show details',
  errorDialogTitle: 'Error details',
  tools: {
    multipleUsed: '{count} tools used',
    multipleRunning: 'Running {count} tools...',
    [BuilderAgentAssistantTools.UpdateAgentConfiguration]: {
      loading: 'Updating agent configuration...',
      success: 'Updated configuration',
      rationale: {
        useCase: 'Use case',
        instructions: 'Instructions',
        semanticModel: 'Semantic model',
        model: 'Model',
        tools: 'Tools',
        capabilities: 'Capabilities',
        introduction: 'Introduction'
      }
    },
    [DataObservatoryCatalogAgentAssistantTools.FilterDatasets]: {
      loading: 'Searching for datasets...',
      success: 'Datasets searched'
    },
    [DataObservatoryCatalogAgentAssistantTools.SearchVariables]: {
      loading: 'Searching for variables...',
      success: 'Variables searched'
    }
  }
}
